
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function SchoolSection() {
  const { t } = useTranslation('common');

  return (
    <section id="school" className="py-24 px-6 bg-gradient-to-br from-blue-50 to-teal-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            {t('services.school.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.school.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/6ebf30970d8a98819eb080ba2b6e1728.jpg"
                alt="International School"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div className="flex gap-4">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-school-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">学校見学サポート</h3>
                <p className="text-gray-600">お子様に最適なインターナショナルスクールを一緒に探します。学校見学のアレンジから通訳まで対応</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-file-list-3-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">転入学手続き代行</h3>
                <p className="text-gray-600">入学申請書類の準備、提出、面接対策まで、煩雑な手続きを全面サポート</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-parent-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">ガーディアンサービス</h3>
                <p className="text-gray-600">保護者様が不在の際も安心。現地での緊急対応や学校との連絡を代行</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-home-heart-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">生活サポート</h3>
                <p className="text-gray-600">住居探し、ビザ取得、銀行口座開設など、マレーシアでの生活立ち上げをサポート</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
